// src/components/ClientsSection.jsx
import React from "react";
import client1 from "./acs.png"; 
import client2 from "./progresion.jpg";
import client3 from "./asia.png";
import client4 from "./sonnedix.png";
import "./TopClientsSection.css";

const TopClientsSection = () => {
    return (
        <section className="gray-section">
            <h2>Nuestros clientes más destacados</h2>
            <div className="clientes-destacados-container">
                <div className="cliente-destacado-card">
                    <div className="cliente-imagen-container">
                        <img src={client1} alt="Cliente 1" />
                    </div>
                    <div className="cliente-texto">
                        <h3>ACS: Actividades de Construcción y Servicios S.A.</h3>
                        <p>Es una empresa constructora española líder global en el desarrollo de infraestructuras con especialización en ingeniería, obra civil, edificación y proyectos de nueva generación.</p>
                    </div>
                </div>

                <div className="cliente-destacado-card">
                    <div className="cliente-imagen-container">
                        <img src={client2} alt="Cliente 2" />
                    </div>
                    <div className="cliente-texto">
                        <h3>Progresión Dinámica</h3>
                        <p>Progresión Dinámica, S.L. es una empresa radicada en Zamora especializada en energía solar fotovoltaica, que combina solidez financiera y eficiencia operativa con el respaldo institucional de Caja Rural de Zamora, apostando por el desarrollo sostenible y la gestión técnica de activos renovables.</p>
                    </div>
                </div>

                <div className="cliente-destacado-card">
                    <div className="cliente-imagen-container">
                        <img src={client3} alt="Cliente 3" />
                    </div>
                    <div className="cliente-texto">
                        <h3>Assyce</h3>
                        <p>Presta un servicio integral de operación y mantenimiento de instalaciones fotovoltaicas desarrolladas por empresas y entidades financieras o fondos de inversión, con vistas a analizar su eficiencia energética y, en caso necesario proponer soluciones de mejora.</p>
                    </div>
                </div>

                <div className="cliente-destacado-card">
                    <div className="cliente-imagen-container">
                        <img src={client4} alt="Cliente 4" />
                    </div>
                    <div className="cliente-texto">
                        <h3>Sonnedix</h3>
                        <p>Es un productor internacional de energía renovable con más de 400 plantas / granjas solares fotovoltaicas en 10 países. Sonnedix se sitúa como la sexta cartera de energía solar fotovoltaica más grande de Europa.</p>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default TopClientsSection;